"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var messaging_response_1 = require("./messaging-response");
/**
 * Serialiser for {@link MessagingResponse}
 */
var MessagingResponseSerialiserClass = /** @class */ (function (_super) {
    __extends(MessagingResponseSerialiserClass, _super);
    function MessagingResponseSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link MessagingResponse} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link MessagingResponse} that was read
     */
    MessagingResponseSerialiserClass.prototype.read = function (bis) {
        var responseDataType = Codec.readString(bis);
        var data = Codec.readBytes(bis);
        return new messaging_response_1.MessagingResponse(responseDataType, data);
    };
    /**
     * Write a {@link MessagingResponse} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link MessagingResponse} to be written
     */
    MessagingResponseSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.responseDataType);
        Codec.writeBytes(bos, value.data);
    };
    return MessagingResponseSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.MessagingResponseSerialiserClass = MessagingResponseSerialiserClass;
/**
 * The {@link MessagingResponseSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.MessagingResponseSerialiser = new MessagingResponseSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/messaging-response-serialiser.js
// module id = 516
// module chunks = 1